import PaymentTransaction from './PaymentTransaction';

export default class AuthTransaction extends PaymentTransaction {
	/**
	 * Get the transaction request type
	 *
	 * @returns
	 */
	getRequestType(): string {
		return 'auth';
	}
}
